export const styles = {
    container: {
        width: '100%',
        padding: [17, 12, 20],
        background: '#FFFFFF',
        borderBottom: '1px solid #E3E3E3',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
    },
    title: {
        margin: 0,
        marginBottom: 13,
        fontFamily: 'Open Sans, Arial, sans-serif',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '135%',
        letterSpacing: '0.75px',
        textTransform: 'uppercase',
        color: '#313140',
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
